import PageFrames from "../ui/pageframes";

const Partners = () => {
  return (
    <PageFrames className="bg-white w-full py-12 px-6 flex justify-center items-center">
      <div className="bg-[#F4F4F4] shadow-md rounded-xl p-6 max-w-4xl flex flex-col lg:flex-row items-center gap-6">
        {/* Brother Logo */}
        <img
          src="/images/auth-reseller/brother.webp"
          alt="Brother Logo"
          className="w-40 h-auto object-contain"
        />

        {/* Description */}
        <div className="text-center lg:text-left">
          <h2 className="text-2xl font-semibold text-[#002F6C]">
            Official Brother Partner
          </h2>
          <p className="mt-2 text-gray-700">
            JK Millennium Computer Centre is a certified partner of Brother,
            giving you access to genuine printers, supplies, and expert support
            — directly backed by Brother Malaysia.
          </p>
        </div>
      </div>
    </PageFrames>
  );
};

export default Partners;
